"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserError = void 0;
class UserError extends Error {
    constructor(title, description) {
        super(title);
        this.title = title;
        this.description = description;
    }
}
exports.UserError = UserError;
//# sourceMappingURL=UserError.js.map